import { render } from "./quranProgram.vue?vue&type=template&id=e8e17d9c&scoped=true"
import script from "./quranProgram.vue?vue&type=script&lang=js"
export * from "./quranProgram.vue?vue&type=script&lang=js"

import "./quranProgram.vue?vue&type=style&index=0&id=e8e17d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e17d9c"]])

export default __exports__